var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.734,
    height: 23.648,
    viewBox: "0 0 22.734 23.648",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-globe",
    "data-name": "Icon feather-globe",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M23.734,13.824A10.6,10.6,0,0,1,13.367,24.648,10.6,10.6,0,0,1,3,13.824,10.6,10.6,0,0,1,13.367,3,10.6,10.6,0,0,1,23.734,13.824Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#b2b1b1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M3,18H23.734",
    transform: "translate(0 -4.176)",
    fill: "none",
    stroke: "#b2b1b1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M16.244,3a16.743,16.743,0,0,1,4.244,10.824,16.743,16.743,0,0,1-4.244,10.824A16.743,16.743,0,0,1,12,13.824,16.743,16.743,0,0,1,16.244,3Z",
    transform: "translate(-2.684)",
    fill: "none",
    stroke: "#b2b1b1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.5d2e79aa197071dd3625e9e79f4aeb27.svg";
export { ForwardRef as ReactComponent };